import { formatDayStrip } from '../model/formatDayStrip'
import { DAY_STRIP_HEIGHT } from '../model/calendarConstants'

interface Props {
  day: Date
  isToday: boolean
}

/**
 * The one-day view's date line: `Montag, 26. Oktober 2026`, across the full width.
 *
 * Replaces the 82px column header, which in a single column would be a stack of weekday, number
 * and month with nothing beside it. One line says all of that in words, never truncates at 320px,
 * and hands about 46px back to the grid. Sticky for the same reason the header was: scrolled to
 * 15:00, the worker still needs to know which day it is.
 */
export const DayStrip = ({ day, isToday }: Props) => {
  const { weekday, date, year } = formatDayStrip(day)

  return (
    <div
      className={`sticky top-0 z-50 flex shrink-0 items-baseline gap-1.5 overflow-hidden whitespace-nowrap border-b border-gray-200 px-3 text-[15px] font-bold ${
        isToday ? 'bg-blue-50 text-blue-700' : 'bg-white text-gray-800'
      }`}
      style={{ height: DAY_STRIP_HEIGHT, lineHeight: `${DAY_STRIP_HEIGHT}px` }}
    >
      <span className={isToday ? 'text-blue-600' : 'text-gray-500'}>{weekday},</span>
      <span>{date}</span>
      <span className={`font-normal ${isToday ? 'text-blue-600/70' : 'text-gray-400'}`}>{year}</span>
    </div>
  )
}
